import { APLLoadingPage } from 'legacy/hpscoutso/components/pages/aplCommon/APLLoadingPage'
import { APLSearchContent } from 'legacy/hpscoutso/components/pages/aplSearch/APLSearchContent'
import { APLPageLayout } from 'legacy/hpscoutso/layout/aplPageLayout/APLPageLayout'
import React, { useState } from 'react'

export function APLSearchPage() {
  const [isLoading, setIsLoading] = useState(true)

  return (
    <APLPageLayout setIsLoading={setIsLoading} isLoading={isLoading}>
      {isLoading ? <APLLoadingPage /> : <APLSearchContent />}
    </APLPageLayout>
  )
}
